import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

/**
Il componente rappresenta un indicatore di occupato dando all'utente l'informazione che un'operazione è in corso.
 */
const Spinner = ({
  center, small, inverted, large,
}) => {
  const classes = cns(
    'spinner',
    {
      'spinner--small': small,
      'spinner--large': large,
      'spinner--inverted': inverted,
      'spinner--centered': center,
    },
  );
  return (
    <div className={classes}>
      <div className="spinner__layer spinner__layer-1">
        <div className="spinner__circle-clipper spinner__left">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__gap-patch">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__circle-clipper spinner__right">
          <div className="spinner__circle" />
        </div>
      </div>
      <div className="spinner__layer spinner__layer-2">
        <div className="spinner__circle-clipper spinner__left">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__gap-patch">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__circle-clipper spinner__right">
          <div className="spinner__circle" />
        </div>
      </div>
      <div className="spinner__layer spinner__layer-3">
        <div className="spinner__circle-clipper spinner__left">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__gap-patch">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__circle-clipper spinner__right">
          <div className="spinner__circle" />
        </div>
      </div>
      <div className="spinner__layer spinner__layer-4">
        <div className="spinner__circle-clipper spinner__left">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__gap-patch">
          <div className="spinner__circle" />
        </div>
        <div className="spinner__circle-clipper spinner__right">
          <div className="spinner__circle" />
        </div>
      </div>
    </div>
  );
};

Spinner.propTypes = {
  /** Indica se centrare lo spinner */
  center: PropTypes.bool,
  /** Inverte i colori dello spinner */
  inverted: PropTypes.bool,
  /** Disegna uno spinner più grande */
  large: PropTypes.bool,
  /** Disegna uno spinner più piccolo */
  small: PropTypes.bool,
};

Spinner.defaultProps = {
  center: false,
  inverted: false,
  large: false,
  small: false,
};

export default Spinner;
